import { createSelector } from 'reselect'
import lessonTypes from 'helpers/enums/lessonTypes'

const lessonsData = state => state.lessons
const getMediaSlidesData = state => state.mediaSlides
const getLibraryLessonsData = state => state.myLibrary.lessons

const myLibraryLessonsIdWithoutData = createSelector(
	[ getMediaSlidesData, getLibraryLessonsData, lessonsData ],
	(mediaSlides, libraryLessons, lessons) => {
		const lessonsIdWithoutData = libraryLessons.filter(lessonUid =>
			lessons[lessonUid].data.type === lessonTypes.VIDEO &&
			mediaSlides.findIndex(mediaSlide => mediaSlide.lessonUid === lessonUid) === -1
		)
		return ({
			lessonsIdWithoutData,
		})
	}
)

export default myLibraryLessonsIdWithoutData
